import 'Plugins/loadMorePlugin';
// load more init
export default function initLoadMore() {
  jQuery('.load-more-holder').loadMore({
		linkSelector: 'a.load-more',
		newContentTarget: '.blog-holder',
	});
}